import React, { useState } from 'react';
import { Container, Row, Col, Button, Badge, Card, Nav } from 'react-bootstrap';
import { motion } from 'framer-motion';

const HeroSection3 = () => {
  const [activeTab, setActiveTab] = useState('breakfast');
  const menuItems = {
    breakfast: [
      { name: 'Avocado Toast', price: '$12.99', rating: 4.8, popular: true },
      { name: 'Pancake Stack', price: '$10.99', rating: 4.7, new: true },
      { name: 'Acai Bowl', price: '$9.99', rating: 4.9, bestseller: true },
    ],
    lunch: [
      { name: 'Quinoa Salad', price: '$14.99', rating: 4.6, popular: true },
      { name: 'Chicken Wrap', price: '$13.99', rating: 4.5 },
      { name: 'Veggie Burger', price: '$11.99', rating: 4.7, new: true },
    ],
    dinner: [
      { name: 'Grilled Salmon', price: '$22.99', rating: 4.9, bestseller: true },
      { name: 'Mushroom Risotto', price: '$18.99', rating: 4.8, popular: true },
      { name: 'Beef Tenderloin', price: '$26.99', rating: 4.9 },
    ]
  };

  const renderRating = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <i key={i} className={`${i < Math.floor(rating) ? 'ri-star-fill text-warning' : 'ri-star-line text-muted'}`} />
    ));
  };

  return (
    <motion.section initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }} className="position-relative hero-section overflow-hidden">
      <Container className="position-relative">
        {/* Header Section */}
        <Row className="justify-content-center text-center">
          <Col xl={8} lg={9} md={10} className="px-4">
            <motion.div initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
              <Badge bg="danger" text="white" className="mb-2 rounded-pill ">
                <i className="text-white ri-leaf-fill me-2" /> 100% Fresh & Organic
              </Badge>
              <motion.h1 initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="display-4 fw-bold mb-2 text-gradient">
                Discover Our <span className="text-danger">Delicious</span> Menu
              </motion.h1>
              <motion.p initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="lead text-muted mx-lg-5 px-xl-5">
                Experience the perfect blend of taste and health with our carefully crafted menu. Every dish is prepared with love and the finest ingredients.
              </motion.p>
            </motion.div>
          </Col>
        </Row>

        {/* Menu Tabs */}
        <Row className="justify-content-center">
          <Col xl={8} lg={10}>
            <Card className="card-hover menu-item-card overflow-hidden">
              <Card.Header className=" border-0 pb-0 pt-4 px-4">
                <Nav variant="pills" className="nav-pills-custom justify-content-center">
                  {['breakfast', 'lunch', 'dinner'].map((tab) => (
                    <Nav.Item key={tab} className="mx-1 mb-3">
                      <Nav.Link eventKey={tab} className={`px-4 py-2 rounded-pill fw-medium`} active={activeTab === tab} onClick={() => setActiveTab(tab)}>
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Card.Header>
              <Card.Body className="p-0">
                <motion.div initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="p-4">
                  {menuItems[activeTab].map((item, index) => (
                    <Card key={index} className='card-hover'>
                      <Card.Body className='d-flex justify-content-between align-items-center'>
                        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }}>
                          <div className="d-flex align-items-center mb-2">
                            <h5 className="mb-0 me-2">{item.name}</h5>
                            {item.popular && <Badge bg="danger" pill className="ms-2">Popular</Badge>}
                            {item.new && <Badge bg="success" pill className="ms-1">New</Badge>}
                            {item.bestseller && <Badge bg="warning" text="dark" pill className="ms-1">Bestseller</Badge>}
                          </div>
                          <div className="text-warning">
                            {renderRating(item.rating)}
                            <small className="text-muted ms-2">{item.rating}</small>
                          </div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="text-end">
                          <h5 className="text-danger mb-2">{item.price}</h5>
                          <div className="rounded avatar avatar-sm bg-soft-danger text-danger cursor" >
                            <i className="ri-shopping-basket-2-line" />
                          </div>
                        </motion.div>
                      </Card.Body>
                    </Card>
                  ))}
                </motion.div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* CTA Buttons */}
        <Row className="mt-2 mb-5">
          <Col className="text-center d-flex align-items-center justify-content-center gap-3 flex-wrap">
            <Button variant="danger" size="lg" >
              <i className="ri-shopping-basket-2-line me-2" /> Order Now
            </Button>
            <Button variant="dark" size="lg" >
              <i className="ri-time-line me-2" /> View Menu
            </Button>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default HeroSection3;
